<template>
  <div class="container mt-4">
    <b-card header-tag="header" class="m-3" no-body>
      <template #header>
        <header-sagres titulo="Editar permissões do usuário nesta UG" :botoes="botoesHeader" breakpoint="xl" />
      </template>
      <b-card>
        <b-container>
          <b-row style="text-align: center">
            <b-col cols="12" lg="6">
              <b-form-group>
                <span style="font-weight: bold">Nome:</span>
                <span style="margin-left: 5px">{{ usuario?.NOME }}</span>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group>
                <span style="font-weight: bold">CPF:</span>
                <span style="margin-left: 5px">{{ usuario?.CPF }}</span>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>

        <b-card-group deck>
          <b-card header="Permissões a serem adicionadas">
            <SeletorDePerfis :perfisSelecionados="perfisSelecionados" :perfisUsuarioUG="perfisUsuarioUG" cin
              @AdicionandoPerfil="addPerfilLista" @removendoPerfil="removerPerfilLista"
              @removerPerfis="removerPerfisLista" />

            <div class="d-flex flex-column align-items-center mt-1">
              <b-button variant="success" size="sm" class="d-block mb-2" :disabled="perfisSelecionados.length === 0"
                @click="addPermissoes">Adicionar permissões</b-button>
            </div>
          </b-card>
          <b-card header="Permissões do usuário">
            <b-table striped hover stacked="md" :items="perfisUsuarioUG" :fields="computedFields">
              <template slot="cell(actions)" slot-scope="perfilData">
                <b-button size="sm" @click="alertaPermissaoRemove(perfilData.item)">
                  <font-awesome-icon icon="trash" />
                </b-button>
              </template>
            </b-table>
          </b-card>
        </b-card-group>
      </b-card>
    </b-card>
  </div>
</template>

<script lang="ts">
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { Component, Vue, Watch } from "vue-property-decorator";
import { store } from "@/store";
import usuarioService from "@/services/administracao/usuarioService";

import HeaderSagres from "@/components/shared/HeaderSagres.vue";
import SeletorDePerfis from "@/components/administracao/usuarios/SeletorDePerfis.vue";
import { Perfil } from "@/types/administracao/cadastro-permissoes/perfil";
import { BotaoSagres } from "@/types/botao-sagres";
import { EnvioUsuarioPermissoes } from "@/types/administracao/usuarios/envio-usuario-permissoes";
import { PropType } from "vue";
import { UsuarioResumido } from "@/types/administracao/usuarios/usuario-resumido";

const CompProps = Vue.extend({
  name: "EditarUsuarioPorUG",
  components: { SeletorDePerfis, HeaderSagres },
  props: {
    usuario: {
      type: Object as PropType<UsuarioResumido>,
      required: true,
    },
  },
});

//Interface própria para o objeto usuario retornado da página anterior
interface perfilUG {
  ID_USUARIO_PERFIL: number;
  DESCRICAO: string;
  ID: number;
}

@Component
export default class EditarUsuarioPorUG extends mixins(UtilsTS, CompProps) {
  user: UsuarioResumido | undefined = undefined;
  perfisSelecionados: Perfil[] = [];
  perfisUsuarioUG: perfilUG[] = [];
  envioPermissoes: EnvioUsuarioPermissoes[] = [];
  botoesHeader: BotaoSagres[] = [
    {
      id: 1,
      icone: "arrow-left",
      texto: "Voltar",
      url: `/seguranca-administracao/usuarios-ug`,
    },
  ];

  created() {
    this.user = this.usuario;
    //console.log(this.user)
    this.atualizarListaPerfisU();
  }

  // titulo do card
  get computedFields() {
    const fields = [{ key: "DESCRICAO", label: "Perfis" }];
    if (this.perfisUsuarioUG.length > 0) {
      fields.push({ key: "actions", label: "" });
    }
    return fields;
  }

  //atualiza lista de perfis já adicionadas ao usuario
  atualizarListaPerfisU() {
    this.perfisUsuarioUG = [];

    this.user?.USUARIO_PERFIL.forEach((perfilUsuario) => {
      const ID_USUARIO_PERFIL = perfilUsuario.idUsuarioPerfil;
      const DESCRICAO = perfilUsuario.perfil.Descricao;
      const ID = perfilUsuario.perfil.Id;

      const novoObjeto: perfilUG = {
        ID_USUARIO_PERFIL,
        DESCRICAO,
        ID,
      };
      const perfilExiste = this.perfisUsuarioUG.some(
        (perfil) => perfil.ID === perfilUsuario.perfil.Id
      );
      if (!perfilExiste) {
        this.perfisUsuarioUG.push(novoObjeto);
      }
    });
  }

  //Atualiza a lista com os dados do emit
  addPerfilLista(listaAtualizada: Perfil[]) {
    this.perfisSelecionados = [];
    this.perfisSelecionados = listaAtualizada;
  }
  //Atualiza a lista com os dados do emit
  removerPerfilLista(listaAtualizada: Perfil[]) {
    this.perfisSelecionados = [];
    this.perfisSelecionados = listaAtualizada;
  }
  //Limpa a lista a partir do sinal do emit
  removerPerfisLista() {
    this.perfisSelecionados = [];
  }

  // Requisição para adicionar as permissões selecionados ao Usuario
  async addPermissoes() {
    this.perfisSelecionados.forEach((perfil) => {
      const idUsuario = Number(this.user?.ID_USUARIO);
      const idUnidadeGestora = this.user?.USUARIO_PERFIL[0].idUnidadeGestora;
      const idPerfil = perfil.Id;
      //console.log(idUnidadeGestora)
      if (!idUnidadeGestora) return this.$toast.error("Id da ug não recebido");

      const novoObjetoPermissaoEnviar: EnvioUsuarioPermissoes = {
        idUsuario,
        idUnidadeGestora,
        idPerfil,
      };
      this.envioPermissoes.push(novoObjetoPermissaoEnviar);
    });

    try {
      store.blockScreen = true;
      const response = await usuarioService.adicionarPermissaoUsuario(
        this.envioPermissoes
      );
      if (this.perfisSelecionados.length === 1)
        this.$toast.success("Permissão adicionada com sucesso!");
      else this.$toast.success("Permissões adicionadas com sucesso!");
      //console.log(response)
      this.atualizarCompAdd(response);
    } catch (e: any) {
      this.tratarError(e);
      this.$toast.error("Erro ao adicionar a permissão");
    } finally {
      //retira tela de carregamento
      store.blockScreen = false;
      //zerando as listas utilizadas
      this.perfisSelecionados = [];
      this.envioPermissoes = [];
      //Chama emit
    }
  }

  async removerItemPerfilUsuario(id: number) {
    //console.log(id)
    try {
      store.blockScreen = true;
      const response = await usuarioService.removerPerfilPermissao(id);
      this.$toast.success("Permissão removida com sucesso!");
      this.removerCompAdd(id);
    } catch (e: any) {
      console.error(e);
      this.$toast.error("Erro ao remover permissão");
    } finally {
      store.blockScreen = false;
    }
  }

  //Atualiza a lista de permissões após uma permissão ser adicionada
  atualizarCompAdd(novasPerms) {
    //console.log(novasPerms)
    novasPerms.forEach((elemento) => {
      const ID_USUARIO_PERFIL = elemento.idUsuarioPerfil;
      const DESCRICAO = elemento.perfil.Descricao;
      const ID = elemento.perfil.Id;

      const objetoAtualizado: perfilUG = {
        ID_USUARIO_PERFIL,
        DESCRICAO,
        ID,
      };
      this.perfisUsuarioUG.push(objetoAtualizado);
    });
  }

  removerCompAdd(idRemover: number) {
    this.perfisUsuarioUG = this.perfisUsuarioUG.filter(
      (elemento) => elemento.ID_USUARIO_PERFIL !== idRemover
    );
    /**for(let p = 0; p<this.perfisUsuarioUG.length; p++){
        if(this.perfisUsuarioUG[p].ID_USUARIO_PERFIL === idRemover){
          this.perfisUsuarioUG.splice(p, 1)
          p--;
        }
      }**/
  }

  //Confirmação para exxcluir um perfil
  alertaPermissaoRemove(perfil: perfilUG): any {
    this.$bvModal
      .msgBoxConfirm(
        `Deseja remover a permissão de ${this.capitalize(perfil.DESCRICAO)} ?`,
        {
          buttonSize: "sm",
          cancelTitle: "Cancelar",
          cancelVariant: "outline-secondary",
          centered: true,
          headerBgVariant: "secondary",
          headerTextVariant: "light",
          okTitle: "Confirmar",
          title: "Remover Permissão",
        }
      )
      .then((value) => {
        if (value) this.removerItemPerfilUsuario(perfil.ID_USUARIO_PERFIL);
      })
      .catch((err) => {
        console.error(
          `Erro ao operar o dialog de alerta de remoção de perfil`,
          err
        );
      });
  }
}
</script>

<style scoped></style>
